import request from '@/router/axios'

export function fetchDeptTree (query) {
  return request({
    url: '/system/dept/user-tree',
    method: 'get',
    params: query
  })
}

export function fetchTree (query) {
  return request({
    url: '/system/dept/tree',
    method: 'get',
    params: query
  })
}

export function addObj (obj) {
  return request({
    url: '/system/dept',
    method: 'post',
    data: obj
  })
}

export function getObj (id) {
  return request({
    url: '/system/dept/' + id,
    method: 'get'
  })
}

export function delObj (id) {
  return request({
    url: '/system/dept/' + id,
    method: 'delete'
  })
}

export function putObj (obj) {
  return request({
    url: '/system/dept',
    method: 'put',
    data: obj
  })
}

export function getdetails (obj) {
  return request({
    url: '/system/dept/details/' + obj,
    method: 'get'
  })
}

